/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { Button } from '@futura-library/ui-library';
import { spei, priceCheck } from '../../../../../../assets/images/Global';
import styles from '../../MethodsFlow.module.css';
import data from '../../data';
import axiosPost from '../../../../../../methods/cashPayments/mx/axiosPost';
import organizeDataPayments from '../../../../../../methods/organizeDataPayments';
import ThankYouContext from '../../../../../../context/ThankYou/Context';
import PaymentContext from '../../../../../../context/Payment/Context';
import ProductContext from '../../../../../../context/Product/Context';
import AlertModal from '../../../../../AlertModal';
import { axiosPutRecalculateCarts } from '../../../../../../methods/products/axiosPut';
import { areThereCartsWithoutEnoughStock } from '../../../../../../utils/stock';
import GlobalContext from '../../../../../../context/Global/Context';
import sendFreshpaintEvent from '../../../../../../utils/sendFreshpaintEvent';
import { availableCountries } from '../../../../../../utils/locale';
import totalPriceCarts from '../../../../../../hooks/totalCarts';

const FlowSpei = () => {
  const productContext = useContext(ProductContext);
  const paymentContext = useContext(PaymentContext);
  const thankYouContext = useContext(ThankYouContext);
  const globalContext = useContext(GlobalContext);
  const [loadingSpeiButton, setLoadingSpeiButton] = useState(false);
  const [preventModal, setPreventModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const { titleSpei, descriptionSpei, stepsSpei, buttonSpei } = data.spei;
  const { hasAddress } = paymentContext;
  const { setDataSpei } = thankYouContext;
  const {
    couponsCode,
    productsWithDiscount,
    carts: cartsProducts,
    order,
  } = productContext;
  const {
    isCitaFlow,
    isOnlyComplementaryPayment,
    isOnlyAdvance,
    name,
    email,
    customerId,
    country,
    publicKey,
    origin,
    setEmptyAddressFunction,
  } = globalContext;
  const totalPrice = totalPriceCarts(cartsProducts, false, order);
  let dataToSpei = organizeDataPayments();
  const carts = new URLSearchParams(window.location.search).getAll('cart');
  const buttonUrl = new URLSearchParams(window.location.search).get(
    'redirectUrl'
  );
  const outOfStockModal = {
    title: '¡Lo sentimos!',
    description:
      'Uno de los productos de tu carrito ya no está disponible. Regresa a la tienda y vuelve a hacer tu selección.',
    button: 'Regresar a la tienda',
    imgAlert: priceCheck,
    urlRedirect: buttonUrl,
    discardLink: buttonUrl,
  };

  const dataToFreshpaint = {
    customer_id: customerId,
    distinct_id: customerId,
    product_id: cartsProducts[0]?.lineItems[0]?.id,
    cart_id: cartsProducts[0]?.id,
    product_quantity: cartsProducts[0]?.lineItems.length,
    public_key: publicKey,
    country_ops: country,
    currency: availableCountries[country.toLocaleLowerCase()].currency,
    payment_method: 'spei',
    product_category: 'appointment',
    product: `appointment-${country.toLocaleLowerCase()}`,
    payment_type: 'Complete',
    platform: 'checkout_futura',
    transaction_amount: cartsProducts[0]?.totalPrice.centAmount / 100,
    name,
    email,
  };

  useEffect(() => {
    if (couponsCode.length !== 0) {
      const productsArray = [];

      productsWithDiscount.forEach((product) => {
        const { images } = product.variant;
        const { centAmount } = product.price.value;
        const productsConvert = {
          id: product.id,
          productId: product.productId,
          name: 'es-MX',
          price:
            totalPrice * 100,
          quantity: product.quantity,
          totalPrice: centAmount * product.quantity,
          images,
        };
        productsArray.push(productsConvert);
      });

      dataToSpei.cartData.totalLineItemQuantity = productsArray.length;
      dataToSpei.cartData.lineItems = productsArray;
    }
  }, [couponsCode]);

  const getSpeiReference = () => {
    (async () => {
      try {
        const { data: upToDateCartData } = await axiosPutRecalculateCarts(
          carts
        );
        if (areThereCartsWithoutEnoughStock(upToDateCartData.carts)) {
          setPreventModal(true);
        } else {
          setPreventModal(false);
          dataToSpei.country = 'México';
          dataToSpei.discountPrice = couponsCode.length > 0 ? true : false;
          dataToSpei.paymentMethodType = 'spei';
          dataToSpei.transactionType = 'product';
          dataToSpei.origin = origin;
          setLoadingSpeiButton(true);
          axiosPost(dataToSpei)
            .then((res) => {
              dataToFreshpaint.attempted_status = true;
              if (origin === 'appointmentv2') {
                sendFreshpaintEvent(
                  'New Checkout - Payment Attempted',
                  dataToFreshpaint
                );
              }
              setDataSpei(res.data);
              setLoadingSpeiButton(false);
              window.location.replace(`${window.location.origin}/payment/spei`);
            })
            .catch(() => {
              dataToFreshpaint.attempted_status = false;
              if (origin === 'appointmentv2') {
                sendFreshpaintEvent(
                  'New Checkout - Payment Attempted',
                  dataToFreshpaint
                );
              }
              setLoadingSpeiButton(false);
            });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setPreventModal(false);
      }
    })();
  };

  return (
    <>
      {preventModal && (
        <AlertModal
          data={outOfStockModal}
          modal={false}
          discardOption={false}
        />
      )}
      <div className={styles.titleContainer}>
        <p className={styles.title}>{titleSpei}</p>
        <img
          className={styles.logo}
          width={68}
          height={16}
          src={spei}
          alt="Spei Logo"
        />
      </div>
      <div className={styles.container}>
        <p className={styles.text}>{descriptionSpei}</p>
        <ul className={styles.list}>
          {stepsSpei.map((step, index) => (
            <li key={step} className={styles.text}>
              <div className={styles.circle}>{index + 1}</div>
              <div className={styles.stepText}>{step}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.button}>
        <Button
          id="Check_Flow_GetReferenceSpei"
          color="blue"
          disabled={disableButton}
          fullWidth
          isButton
          label={buttonSpei}
          rel="noopener noreferrer"
          size="medium"
          variant="filled"
          loading={loadingSpeiButton}
          onClick={() => getSpeiReference()}
        />
      </div>
    </>
  );
};

export default FlowSpei;
